// removed by extract-text-webpack-plugin
module.exports = {"container":"ovz9F-f2n4RIPbUnSHzvR","image":"_2kK9E4FUV4nk4IOP6GuKNg","fadeInUp":"_3MS0Cb2ORybfB4FO8UKo46","none":"_19F0ZZVCG0R9XPYPBb3eiY","details":"_3fnIWqCmyTfMuOsHdH-aWl","fadeInUpImg":"_2-CL0DbeYpBxw-J_nz8O9q","content":"_3TIztvOiXpklndurbSicls","url":"_2puM0fbtzsDYGWK7eGciII","title":"_3BpU5YwuIZuYdq8imnxLvJ","price":"_3yBh8wg37qfMS2D6dJXjNF","link":"_1Ak-U00_CzCN0RoKFVxMqL"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/Item/Item.scss
 ** module id = 735
 ** module chunks = 0
 **/